<script>
import Icon from './Icon.vue';

export default {
  components: { Icon },

  props: {
    name: String,
    icon: String,
    target: String,
  },

  data() {
    return {
      dataTarget: '#' + this.target,
    };
  },

  mounted() {},
};
</script>

<template>
  <button
    class="dropdown-item dropdown-toggle d-sm-inline-block"
    type="button"
    data-toggle="collapse"
    :data-target="dataTarget"
    aria-expanded="false"
    :aria-controls="target"
  >
    <Icon :class="icon" />
    {{ name }}
  </button>
</template>
